module.exports = __webpack_public_path__ + "static/media/ps.33a2122a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ps.svg
// module id = 748
// module chunks = 0